import { Pipe, PipeTransform } from '@angular/core';
import { LMFieldUtilService } from '@services/utils';

@Pipe({
  name: 'isBlankValue'
})
export class LMModelFieldIsBlankPipe implements PipeTransform {

  constructor(private lmFieldUtilService: LMFieldUtilService) {
  }

  transform(modelFieldValue, specField: LMSpecField): boolean {
    return this.lmFieldUtilService.isBlank(specField.type, modelFieldValue);
  }
}
